var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreciseLocationSsSelected({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 43,
    viewBox: "0 0 30 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0086 14.7143C29.0086 20.2 19.6724 34.5238 15.0043 41C10.4659 34.3968 0.999783 20.4286 1 14.7143C1.00025 8.2269 6.05711 1 15.0043 1C23.9515 1 29.0086 7.85714 29.0086 14.7143Z",
    fill: "#EE4360",
    stroke: "#EE4360",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 14C23 14.0481 22.9996 14.0962 22.9987 14.1441V13.8559C22.9996 13.9038 23 13.9519 23 14ZM15 22C17.2088 22 19.2086 21.1048 20.6562 19.6575L17.8278 16.8291C17.104 17.5525 16.1042 18 15 18C12.7909 18 11 16.2091 11 14C11 11.7909 12.7909 10 15 10C16.1042 10 17.104 10.4475 17.8278 11.1709L20.6562 8.34251C19.2086 6.89517 17.2088 6 15 6C10.5817 6 7 9.58172 7 14C7 18.4183 10.5817 22 15 22Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreciseLocationSsSelected);
export default __webpack_public_path__ + "static/media/precise-location-ss-selected.9e1652b6a93bcd49b172142513c29db1.svg";
export { ForwardRef as ReactComponent };